import { Assignation } from '../context/types'
import _ from 'lodash'

// toStr(_.pick(a,[
//     'id',
//     'valueKey',
//     'bucket'
// ]))

// const newLine = '\n'.charCodeAt(0);
// const cr = '\r'.charCodeAt(0);

// let s = 'abc';
// let c = s.at(1)
// let d = s.charAt(1)

const nl10 = String.fromCharCode(10)
// console.log(`Test${nl10}Test`)
// const nl11 =  String.fromCharCode(11);
// console.log(`Test${nl11}Test`)
// const nl12 =  String.fromCharCode(12);
// console.log(`Test${nl12}Test`)

// String.fromCharCode() // 10, 11, 12

const sortByIndex = (a1: Assignation, a2: Assignation) => a1.index - a2.index
export const stm2str = ({
    id,
    valueKey,
    bucket,
    index,
    roundNumber,
}: Assignation | any) =>
    `${formatNr(index)}/  (${formatNr(id)}) R${formatNr(roundNumber)} B${formatNr(bucket)} - ${valueKey}`

const formatNr = (nr: number | string) => {
    if (nr === undefined || nr === null) {
        return 'XX'
    }
    return String(nr).padStart(2, '0')
}

export const stms2str = (as: readonly Assignation[] | any[]) =>
    `Asgs (${as?.length}):${nl10}${as
        // .toSorted(sortByIndex) // FIXME only "rank"
        .map((a) => stm2str(a) + nl10)}`

export const rounds2str = (rounds: readonly Assignation[][]) =>
    [
        '===round1===\n',
        stms2str(rounds[0]),
        '===round2===\n',
        stms2str(rounds[1]),
        '===round3===\n',
        stms2str(rounds[2]),
    ].join(nl10)

export const buckets2str = (buckets: readonly Assignation[][]) =>
    [
        '===bucket1===\n',
        stms2str(buckets?.[0]),
        '===bucket2===\n',
        stms2str(buckets?.[1]),
        '===bucket3===\n',
        stms2str(buckets?.[2]),
        '===bucket4===\n',
        stms2str(buckets?.[3]),
        '===bucket5===\n',
        stms2str(buckets?.[4]),
        '===bucket6===\n',
        stms2str(buckets?.[5]),
        '===bucket7===\n',
        stms2str(buckets?.[6]),
        '===bucket8===\n',
        stms2str(buckets?.[7]),
        '===bucket9===\n',
        stms2str(buckets?.[8]),
    ].join(nl10)
// rounds.map((r, i) => `>>> R${i + 1}:${nl10}${nl10}${stms2str(r) + nl10}`)
